import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]

  connect() {
    // Optional: Log for debugging
    console.log("Template selector controller connected")
  }

  handleChange(event) {
    const value = event.target.value
    const searchParams = new URLSearchParams(window.location.search)
    searchParams.set("template_id", value)
    window.location.search = searchParams.toString()
  }
}